import React, { useEffect, useState } from 'react';
import { useParams } from 'react-router-dom';
import { app } from '../../firebase';
import { doc, getDoc ,getFirestore } from "firebase/firestore"; 
import Icon from '../Icons';
import { CONTENT_TYPE } from '../constants';
import Loader from './Loader';

const Project = () => {
    const {id} = useParams();
    const [data, setData] = useState();
    const [loader, setLoader] = useState(false);
    const [error, setError] = useState("");
    const [imageLoader, setImageLoader] = useState(true);

    useEffect(() => {
        setLoader(true);
        const getData = async () => {
            const db = getFirestore(app);
            getDoc(doc(db, "projectsPortfolio", id))
            .then(result => {
                setData({ ...result.data() })
                setLoader(false);
            })
            .catch(error => {
                setError(error)
                setLoader(false);
            })
        }
        getData();
    }, [id])

    const handleLoader = () => {
        setImageLoader(false);
    } 

    const handleScrollUp = () => {
        window.scrollTo({ top: 0, behavior: 'smooth'});
    }


    return (
        loader ?  <Loader />
        :
        (error === "" 
        ?
            <div>
                <div>
                    {data?.values?.map((section) => {
                        if (section.type === CONTENT_TYPE.IMAGE) {
                            return (
                                <div key={section.id} >
                                    <img src={section.value} alt="projectImage" onLoad={handleLoader} onError={handleLoader} />
                                    {imageLoader && <Loader />}
                                </div>
                            )
                        } else return <></>
                    })}
                </div>
                <div className='scrollUpBox cursor-pointer' onClick={handleScrollUp} >
                    <Icon iconType="scrollUp" height="40px" width="40px" />
                </div>
            </div>
        : <div>{error}</div>
        )
    )
};

export default Project;